export const classes = {
  track: 'h-2 w-full overflow-hidden rounded-[6px] bg-[rgba(120,110,100,0.07)]',
  fill: 'h-full rounded-[6px] transition-[width] duration-300',
  defaultFill: 'bg-grad',
};

export const styles = {
  fill: (width: number, color?: string) => ({
    width: `${width}%`,
    ...(color && { backgroundColor: color }),
  }),
};
